<template>
  <div class="ak-mobile-viewport-text">
    <ak-box
      size="small"
      class="bb mb-small text-center mobile-mockup__transparent-block"
    >
      <ak-icon type="person" size="large" class="block" />
      <span>{{ from }}</span>
    </ak-box>

    <div class="text-tiny text-center">
      <strong>Text Message</strong>
      <br />
      <strong>Today, </strong>
      09:15
    </div>

    <ak-box size="small" class="relative pb" narrow>
      <ak-box size="tiny" class="bg-grey-lightest" rounded>
        <slot />
      </ak-box>
    </ak-box>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Box from '../box/Box.vue'
import Icon from '../icon/Icon.vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-mobile-view-port-text />
   */
  name: 'AkMobileViewPortText',

  /**
   * @type {Object}
   * @description A collection of components that this component
   * is dependant on.
   */
  components: {
    [Box.name]: Box,
    [Icon.name]: Icon,
  },

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    /**
     * @type {String}
     * @description The default from number to display in the ui
     */
    from: {
      type: String,
      default: '+441143597029',
    },
  },
})
</script>

<style lang="scss">
@import '../../scss/_settings.scss';
</style>
